import { DropdownMenu, GhostIconButton, MenuItem } from "@certn/cascadia-react";
import { t } from "i18next";
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { GroupActiveToggleModal } from "./modals/GroupActiveToggleModal";
import { useCanUpdateGroups } from "../../../components/permissions/Permissions";

interface Props {
  groupId: string;
  groupName: string;
  isActive: boolean;
  mutate: () => void;
}

export function GroupDropdownMenu(props: Props) {
  const { groupId, groupName, isActive, mutate } = props;
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const { groupId: groupIdParam } = useParams();

  const handleDeactivateGroup = async () => {
    setIsOpen(false);
    await mutate?.();
  };

  return (
    <>
      <DropdownMenu
        triggerButton={<GhostIconButton size="small" icon="more_horiz" />}
        placement="bottom right"
        onItemAction={(key) => {
          switch (key) {
            case "toggle_group_active":
              setIsOpen?.(true);
              break;
            case "view_group_details_button":
              navigate(`/groups/${groupId}`);
              break;
            case "view_group_overview_button":
              navigate(`/cases?customer_group_id=${groupId}`);
              break;
            default:
              break;
          }
        }}
      >
        {!groupIdParam && ( // Only show view details button if not already on the group details page
          <MenuItem
            id="view_group_details_button"
            minWidth="196px"
            textColor="text-base"
            textStyle="input/text-field"
          >
            {t("View details")}
          </MenuItem>
        )}
        {groupIdParam && ( // if on details page include option to go to group page
          <MenuItem
            id="view_group_overview_button"
            minWidth="196px"
            textColor="text-base"
            textStyle="input/text-field"
          >
            {t("View group page")}
          </MenuItem>
        )}
        {useCanUpdateGroups() && (
          <MenuItem
            id="toggle_group_active"
            minWidth="196px"
            textColor={isActive ? "text-danger" : "text-base"}
            textStyle="input/text-field"
          >
            {isActive ? t("Deactivate group") : t("Reactivate group")}
          </MenuItem>
        )}
      </DropdownMenu>
      {isOpen && (
        <GroupActiveToggleModal
          groupId={groupId}
          groupName={groupName}
          isActive={isActive}
          onClose={() => setIsOpen(false)}
          onSuccess={handleDeactivateGroup}
        />
      )}
    </>
  );
}
